export class FloatingMenuItem{
  unclickedClass: string;
  clickedClass: string;
  type: string;
  clickeable: boolean;
  
  constructor(obj){
    this.unclickedClass = obj.unclicked_class;
    this.clickedClass = obj.clicked_class;
    this.type = obj.action_type;
    this.clickeable = obj.clickeable;
  }
}